import React from 'react';
import viewMore from "../../../assets/images/viewmore.png";
import print from "../../../assets/images/print.gif";
import {getDateSlash} from "../../../utility/DateUtils";

const BottomResult = ({drawAt}) => {
    return (
        <center>
            <div className="bangkq6x36 bkqtt4">
                <div className="title">
                    <table border={0} cellPadding={0} cellSpacing={0} width="100%">
                        <tbody>
                        <tr>
                            <td className="title">
                                <a href="/">
                                    Kết quả xổ số Thần Tài 4
                                </a>
                            </td>
                            <td align="right" className="mothuong">
                                <a className="thu_mo_thuong" href="/">
                                    Mở thưởng Thứ sáu ngày &nbsp;{getDateSlash(drawAt)}
                                </a>
                                <a
                                    className="viewmore"
                                    href="/"
                                    target="_blank"
                                >
                                    <img
                                        align="absMiddle"
                                        alt=""
                                        border={0}
                                        hspace={5}
                                        src={viewMore}
                                    />
                                    Xem thêm
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="content">
                    <div className="lotto-result">
                        <div id="result-games">
                            <div className="box-result-detail">
                                <ul className="result-number">
                                    <div className="finnish1 bool">
                                        3
                                    </div>
                                    <div className="finnish2 bool">
                                        4
                                    </div>
                                    <div className="finnish3 bool">
                                        3
                                    </div>
                                    <div className="finnish4 bool">
                                        3
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bangkq6x36">
                <div className="title">
                    <table border={0} cellPadding={0} cellSpacing={0} width="100%">
                        <tbody>
                        <tr>
                            <td className="title">
                                <a href="/">
                                    Kết quả xổ số điện toán Mega 6X45
                                </a>
                            </td>
                            <td align="right" className="mothuong">
                                <a
                                    className="viewmore"
                                    href="/"
                                    title="In vé dò (in bảng kết quả xổ số) Mega 6/45 ngày 19/12/2021"
                                >
                                    {" "}
                                    <img
                                        align="absMiddle"
                                        alt=""
                                        border={0}
                                        hspace={5}
                                        src={print}
                                    />
                                    In vé dò
                                </a>
                                <a
                                    className="viewmore"
                                    href="/"
                                    target="_blank"
                                >
                                    <img
                                        align="absMiddle"
                                        alt=""
                                        border={0}
                                        hspace={5}
                                        src={viewMore}
                                    />
                                    Xem thêm
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="content">
                    <div className="lotto-result">
                        <div id="result-games">
                            <div className="box-result-detail">
                                <ul className="result-number">
                                    <li>
                                        <div className="finnish1 bool">
                                            12
                                        </div>
                                    </li>
                                    <li>
                                        <div className="finnish2 bool">
                                            15
                                        </div>
                                    </li>
                                    <li>
                                        <div className="finnish3 bool">
                                            24
                                        </div>
                                    </li>
                                    <li>
                                        <div className="finnish4 bool">
                                            30
                                        </div>
                                    </li>
                                    <li>
                                        <div className="finnish5 bool">
                                            36
                                        </div>
                                    </li>
                                    <li>
                                        <div className="finnish6 bool">
                                            45
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </center>
    );
};

export default BottomResult;
